/**
 * What the Import page says it can read.
 *
 * The server sends every document type the environment accepts
 * (`import_types` from GET /wizard/progress), each marked `featured` once it
 * has its own checked prompt — mortgage statements first, then auto loans,
 * investments and credit cards as each phase ships. The page names only the
 * featured types, so its wording keeps up with the rollout by itself; other
 * accepted types (QA testing) still upload, they just aren't advertised.
 */

// Import types whose files are statements combined over time (the statement tips apply).
const STATEMENT_TYPES = new Set(['credit_card', 'bank', 'spreadsheet', 'hsa']);

const GENERAL_INTRO =
  "Upload statements and documents you already have and we'll fill in what we can recognize as a starting point.";

/** "a, b and c" from the types' labels. */
export function typeList(types) {
  const labels = types.map((t) => t.label);
  if (labels.length <= 1) return labels[0] || 'documents';
  return `${labels.slice(0, -1).join(', ')} and ${labels[labels.length - 1]}`;
}

const PDF_ONLY = '.pdf';
const PDF_AND_SPREADSHEETS = '.pdf,.csv,.xlsx,.xlsm';

/**
 * The page's intro sentence, which tips apply and what the file picker offers:
 *   intro        — names the featured types (general wording when none are)
 *   statements   — monthly-statement tips (a year of statements, each account)
 *   spreadsheets — CSV / Excel downloads are mentioned
 *   accept       — the picker's file types: spreadsheets only where the server
 *                  takes them at all (enabled, featured or not)
 */
export function importCopy(importTypes) {
  const takesSpreadsheets = !importTypes || importTypes.some((t) => t.key === 'spreadsheet');
  const accept = takesSpreadsheets ? PDF_AND_SPREADSHEETS : PDF_ONLY;
  const featured = (importTypes || []).filter((t) => t.featured);
  if (!featured.length) return { intro: GENERAL_INTRO, statements: true, spreadsheets: takesSpreadsheets, accept };
  return {
    intro: `Upload your ${typeList(featured)} and we'll fill in what we can recognize as a starting point.`,
    statements: featured.some((t) => STATEMENT_TYPES.has(t.key)),
    spreadsheets: featured.some((t) => t.key === 'spreadsheet'),
    accept,
  };
}
